<div class="date-picker-container">
    <div class="label-container tapestry-body body--sm">
        <div class="tapestry-body bold">
            {{ labelText }}
        </div>
        @if (isOptional) {
            <div class="optional-text-label tapestry-body">
                ({{ optionalLabel }})
            </div>
        }
    </div>
    <div class="tapestry-body body--sm">
        <input
            class="date-picker-input tapestry-body body--xs"
            [(ngModel)]="value"
            [owlDateTimeTrigger]="dt"
            [owlDateTime]="dt"
            [min]="minDate"
            [max]="maxDate"
            (dateTimeChange)="handleUpdateDates($event)"
            [piTesting]="testingAttribute"
            [readOnly]="true"
            [disabled]="disabled"
        />
        <tapestry-icon
            name="calendar"
            class="date-picker-calendar-icon"
            [ngStyle]="{ 'margin-right': rightMarginCalendar }"
            [ngClass]="{ 'date-picker-calendar-icon--disabled': disabled }"
        ></tapestry-icon>
        @if (value) {
            <tapestry-icon-button
                iconName="close_page"
                (click)="clearDate()"
                class="date-picker-cancel-button"
                submitType="button"
            ></tapestry-icon-button>
        }
        <owl-date-time
            pickerType="calendar"
            #dt
            [startAt]="value"
        ></owl-date-time>
    </div>
</div>
